import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../abilities/Can';
import { isAISearchSupportedModule } from '../helpers/searchUtils';

/** Context for AI: the single gate for NLS, Search-by-Image and the ECA half of Hybrid Search — the ai_similarity_search ECA AND a supported-module allow-list. "Similarity search" and NLS are the same capability. */
export const useCanUseSimilaritySearch = () => {
	const ability = useAbility(AbilityContext);
	const isSimilaritySearchECA = ability.can('show', 'ai_similarity_search');

	const canUseSimilaritySearch = isSimilaritySearchECA && isAISearchSupportedModule();

	return { canUseSimilaritySearch };
};
